export default {
  namespaced: true,
  state: {
    //所有商品(無巢狀階層/包含product的detail buttons)
    allProducts: {},
    //所有容量對應的加料清單
    allProductsAddOn: {},
    //商品tab清單&對應的products(巢狀階層/不包含product的detail buttons)
    tabList: [],
    //整筆訂單的折扣清單
    entertainList: [],
    //電子券活動清單
    ticketList: [],
    //選擇不同的tab對應的products清單
    itemList: {},
    //選擇不同的商品對應的detail buttons清單
    detailBtns: {
      size: [],
      temperature: [],
      sweetness: [],
      add_on: [],
    },
    //選擇不同商品對應的折扣清單
    discountList: [],
    //選擇不同size對應的全部加料清單
    allAddOnList: [],
  },

  getters: {
    getAllProducts: (state) => state.allProducts,
    getAllProductsAddOn: (state) => state.allProductsAddOn,
    getTabList: (state) => state.tabList,
    getEntertainList: (state) => state.entertainList,
    getTicketList: (state) => state.ticketList,
    getItemList: (state) => state.itemList,
    getDetailBtns: (state) => state.detailBtns,
    getDiscountList: (state) => state.discountList,
    getAllAddOnList: (state) => state.allAddOnList,
    //判斷選擇之品項的detail清單，小於1代表該品項沒得選擇(目前沒有用)
    isNoChoose: (state) => {
      if (
        state.detailBtns.temperature?.length < 1 &&
        state.detailBtns.sweetness?.length < 1 &&
        (state.allAddOnList?.length < 1 || !state.allAddOnList) &&
        (state.detailBtns.size.add_on?.length < 1 || !state.detailBtns.size.add_on)
      ) {
        if (state.detailBtns.size?.length === 0) return false;
        else if (state.detailBtns.size?.length === 1 && state.detailBtns.size[0]?.price_type === 1) return false;
      }
      return false;
    },
  },

  mutations: {
    SET_ALL_PRODUCTS(state, data) {
      state.allProducts = data;
    },
    SET_ALL_PRODUCTS_ADD_ON(state, data) {
      state.allProductsAddOn = data;
    },
    SET_TAB_LIST(state, data) {
      state.tabList = data;
    },
    SET_ENTERTAIN_LIST(state, data) {
      state.entertainList = data;
    },
    SET_ALL_ADD_ON_LIST(state, data) {
      state.allAddOnList = data;
    },
    SET_ITEM_LIST(state, data) {
      state.itemList = data;
    },
    SET_DETAIL_BTNS(state, data) {
      state.detailBtns.size = data.size || [];
      state.detailBtns.temperature = data.temperature || [];
      state.detailBtns.sweetness = data.sweetness || [];
    },
    SET_ADD_ON_BTNS(state, data) {
      state.detailBtns.add_on = data || [];
    },
    SET_DISCOUNT_LIST(state, data) {
      state.discountList = data;
    },
    SET_TICKET_LIST(state, data) {
      state.ticketList = data;
    },
    CLEAR_ITEM_DETAIL(state) {
      state.detailBtns = {
        size: [],
        temperature: [],
        sweetness: [],
        add_on: [],
      };
      state.discountList = [];
      state.allAddOnList = [];
    },
    RESET(state) {
      state.allProducts = {};
      state.allProductsAddOn = {};
      state.tabList = [];
      state.entertainList = [];
      state.ticketList = [];
      state.itemList = {};
      state.detailBtns = {
        size: [],
        temperature: [],
        sweetness: [],
        add_on: [],
      };
      state.discountList = [];
      state.allAddOnList = [];
    },
  },

  actions: {},
};
